import * as React from 'react'
import { BLUE } from '../../colors'

const IconDelete = (props) => (
  <svg width={24} height={24} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M8.744 7.37c.514 0 .93.414.93.926v11.111a.927.927 0 0 1-.93.926.927.927 0 0 1-.93-.926V8.297c0-.513.415-.927.93-.927zm3.682 0a.93.93 0 0 1 .93.926v11.111a.93.93 0 0 1-1.86 0V8.297c0-.513.415-.927.93-.927zm3.675 0c.515 0 .93.414.93.926v11.111a.93.93 0 0 1-1.86 0V8.297a.93.93 0 0 1 .93-.927zm2.944 14.47a.31.31 0 0 1-.31.308H6.185a.314.314 0 0 1-.31-.308V5.247h13.171V21.84zM9.674 2.16c0-.166.142-.308.31-.308h4.878a.31.31 0 0 1 .31.308v1.235H9.673V2.16zm7.357 1.235V2.16c0-1.19-.973-2.16-2.17-2.16H9.984c-1.197 0-2.17.97-2.17 2.16v1.235H2.93a.93.93 0 0 0-.93.926.93.93 0 0 0 .93.926h1.084V21.84c0 1.19.974 2.16 2.17 2.16h12.552c1.196 0 2.169-.97 2.169-2.16V5.247h1.165a.927.927 0 1 0 0-1.852h-5.039z'
      fill={props.color ?? BLUE}
      fillRule='evenodd'
    />
  </svg>
)

export default IconDelete
